import { render } from "./BuscarMovOrigen.vue?vue&type=template&id=010203b1&scoped=true"
import script from "./BuscarMovOrigen.vue?vue&type=script&lang=js"
export * from "./BuscarMovOrigen.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010203b1"]])

export default __exports__